/**
 * Subscription Downgrade Trigger Component
 *
 * Trigger: "cancelled a subscription"
 * Shows: Stripe plan select (optional)
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';
import { StripePlanFields } from '../components/StripePlanFields';

export const SubscriptionDowngradeTrigger: FC<TriggerComponentProps> = ({
  automation,
  index,
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    const planName = automation.stripePlan?.nickname;
    if (planName) {
      return <span>{t('automations.triggers.cancelledSubscriptionFor', { plan: planName })}</span>;
    }
    return <span>{t('automations.triggers.cancelledSubscription')}</span>;
  }

  // Edit mode - show stripe plan selection (no trial/every-payment checkboxes)
  return (
    <StripePlanFields
      automation={automation}
      index={index}
      showTrialOptions={false}
      hideEveryPayment
    />
  );
};
